document.addEventListener('DOMContentLoaded', function () {
    // Assuming these elements exist in your HTML
    const sizeSelect = document.querySelector('.variations_form select#pa_size')
    const quantityInput = document.querySelector('.variations_form input[name="quantity"]')
    const lookupTable = buildLookupTable() // Build the lookup table once the DOM is fully loaded
    let timeoutId
    const timeout = 100

    sizeSelect.addEventListener('change', updatePriceDisplay)
    quantityInput.addEventListener('input', updatePriceDisplay)
    quantityInput.addEventListener('change', updatePriceDisplay)

    document.querySelector('.reset_variations').addEventListener('click', function() {
        quantityInput.value = '1';
    });

    // Initialize with the default selected options
    updatePriceDisplay()

    // Create a MutationObserver instance
    const observer = new MutationObserver((mutationsList, observer) => {
        for(let mutation of mutationsList) {
            if (mutation.type === 'childList') {
                const priceElement = document.querySelector('.single_variation .price')
                if (priceElement) {
                    observer.disconnect(); // Disconnect the old observer

                    // Create a new observer for the priceElement
                    const priceObserver = new MutationObserver((mutationsList, observer) => {
                        for(let mutation of mutationsList) {
                            if (mutation.type === 'childList' || mutation.type === 'attributes') {
                                updatePriceDisplay()
                            }
                        }
                    });

                    // Start observing the priceElement with the configured parameters
                    priceObserver.observe(priceElement, { attributes: true, childList: true, subtree: true });
                }
            }
        }
    });

    // Start observing the document with the configured parameters
    observer.observe(document, { childList: true, subtree: true });


    function buildLookupTable () {
        const table = document.querySelector('.variations-table')
        const headers = table.querySelectorAll('th')
        const rows = table.querySelectorAll('tr')
        const lookup = {}

        // Start from 1 to skip the "Size" column header
        const quantityRanges = Array.from(headers).slice(1).map(header => header.textContent.trim())

        rows.forEach((row, rowIndex) => {
            // Skip the header row
            if (rowIndex === 0) {
                return
            }

            const cells = row.querySelectorAll('td')
            const size = cells[0].querySelector('.size-popup').textContent.trim().replace('"', '')

            cells.forEach((cell, cellIndex) => {
                // Skip the size cell
                if (cellIndex === 0) {
                    return
                }

                const price = parseFloat(cell.textContent.replace('$', '').trim())
                const quantityRange = quantityRanges[cellIndex - 1] // Adjust index for the size column offset
                const key = `${ size }-${ quantityRange }`

                lookup[key] = price
            })
        })

        return lookup
    }

    function getPrice (size, quantity, lookup) {
        const quantityRange = Object.keys(lookup).find(range => {
            const [rangeSize, minQuantity, maxQuantity] = range.split('-') // Adjust here
            if (rangeSize !== size.toString()) {
                return false
            }

            const min = Number(minQuantity)
            const max = Number(maxQuantity)
            return quantity >= min && quantity <= max
        })

        // console.log(`quantityRange: ${ quantityRange }`) // Add this line
        // console.log(`size: ${ size }`) // Add this line
        // console.log(`quantity: ${ quantity }`) // Add this line

        return lookup[quantityRange]
    }

    function formatPrice (price, label) {
        return `<span class="woocommerce-Price-currencySymbol">$${ price.toFixed(2) } <span class="small">${ label }</span></span>`
    }

    function updatePriceDisplay () {
        clearTimeout(timeoutId) // Clear the timeout if it's already set

        timeoutId = setTimeout(() => {
            const size = parseInt(sizeSelect.value)
            const quantity = parseInt(quantityInput.value, 10)
            const priceElement = document.querySelector('.single_variation .price')

            if (!size || isNaN(quantity)) {
                // console.log('Please select a size and enter a valid quantity.')
                return
            }

            let priceEach = getPrice(size, quantity, lookupTable)
            let priceTotal = priceEach * quantity
            // console.log(`The price for size ${ size }" and quantity ${ quantity } is $${ priceEach }.`)
            // console.log(`The total price is $${ priceTotal }.`)
            // console.log(`The value of the price element is ${ priceElement.textContent }.`)

            // Format the prices
            const formattedPriceEach = formatPrice(priceEach, 'each')
            const formattedPriceTotal = formatPrice(priceTotal, 'total')

            // Select the price element and update its innerHTML
            priceElement.innerHTML = `<p class="formatted-price">${ formattedPriceEach } ${ formattedPriceTotal }</p>`

        }, timeout)
    }


})
